// Hero Slider - Swiper Module
import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  if (!customElements.get("hero-slider")) {
    class HeroSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.prevButton = this.querySelector(".hero-banner__slider-nav--prev");
        this.nextButton = this.querySelector(".hero-banner__slider-nav--next");
        this.pagination = this.querySelector(".hero-banner__slider-pagination");

        requestAnimationFrame(() => {
          this.initSwiper();
        });
      }

      initSwiper() {
        const swiperEl = this.querySelector(".swiper");
        if (!swiperEl) {
          console.warn("Swiper element not found");
          return;
        }

        const swiperWrapper = swiperEl.querySelector(".swiper-wrapper");
        if (!swiperWrapper) {
          console.warn("Swiper wrapper not found");
          return;
        }

        const slides = swiperWrapper.querySelectorAll("hero-banner");
        if (slides.length === 0) {
          console.warn("No slides found");
          return;
        }

        let autoplay = false;
        if (this.attributes.getNamedItem("data-autoplay").value == "true") {
          autoplay = {
            delay: Math.max(500, parseInt(this.attributes.getNamedItem("data-delay").value)),
            pauseOnMouseEnter: this.attributes.getNamedItem("data-pause").value == "true"
          };
        }

        let swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 300,
          loop: true,
          autoplay: autoplay,
          grabCursor: true,
          observer: true,
          observeParents: true,
        };
        if (this.nextButton || this.prevButton) {
          swiperOptions.navigation = {};
          if (this.nextButton) {
            swiperOptions.navigation.nextEl = this.nextButton;
          }
          if (this.prevButton) {
            swiperOptions.navigation.prevEl = this.prevButton;
          }
        }
        if (this.pagination) {
          swiperOptions.pagination = {
            clickable: true,
            el: this.pagination,
            bulletClass: 'hero-banner__slider-pagination--item',
            bulletActiveClass: 'hero-banner__slider-pagination--active',
            clickableClass: 'hero-banner__slider-pagination--clickable',
            horizontalClass: 'hero-banner__slider-pagination--horizontal',
            verticalClass: 'hero-banner__slider-pagination--vertical'
          };
        }

        this.swiper = new Swiper(swiperEl, swiperOptions);
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            let slideEl = event.target.closest("hero-banner") || event.target;
            let targetIndex = [...slides].indexOf(slideEl);
            if (targetIndex >= 0) {
              this.swiper.slideTo(targetIndex);
            }
          });
        }
      }

      reInit() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }
    }

    customElements.define("hero-slider", HeroSlider);
  }
})();
